import React from "react";
import "./Collage_dashboard_buckets.css"
import Dashboard_buckets_card from "../../../../../common_components/dashboard_buckets_card/Dashboard_buckets_card";

function Collage_dashboard_buckets() {
  // Data Array
  const bucketData = [
    {
      imgSrc: "/assets/images/icon/girls_boys.webp",
      number: "25",
      heading_text: "Total Interns",
      text: "Total interns at all stages"
    },
    {
      imgSrc: "/assets/images/icon/globe_degree.webp",
      number: "12",
      heading_text: "Abroad Applicants",
      text: "Students applying abroad"
    },
    {
      imgSrc: "/assets/images/icon/verified_doc.webp",
      number: "€800",
      heading_text: "Available Offers",
      text: "Check offers open for approval"
    },

  
   
  ];

  return (
    <>
      <section className="Dashboard_buckets Collage_dashboard_buckets">
        <div className="heading_text_holder">
          <h2>Welcome Sorbonne University</h2>
        </div>

        <div className="row">
          {bucketData.map((item, index) => (
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 mb-3" key={index}>
              <Dashboard_buckets_card
                imgSrc={item.imgSrc}
                number={item.number}
                heading_text={item.heading_text}
                text={item.text}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Collage_dashboard_buckets;
